// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ConfirmationAlert_modalWrapper__0Aaf9"};